import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { apiError } from "../lib/api";
import { Gem, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      const u = await login(email, password);
      toast.success(`Selamat datang, ${u.name}`);
      nav(u.role === "owner" ? "/dashboard" : "/home");
    } catch (e2) {
      setErr(apiError(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden">
      <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 30% 20%, rgba(234,179,8,0.10), transparent 45%), radial-gradient(circle at 80% 80%, rgba(234,179,8,0.06), transparent 40%)" }} />
      <div className="relative w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <div className="h-16 w-16 rounded-2xl flex items-center justify-center mb-4" style={{ background: "linear-gradient(135deg,#EAB308,#CA8A04)" }}>
            <Gem className="h-8 w-8 text-[#0B0E14]" />
          </div>
          <h1 className="font-head text-3xl font-bold tracking-tight">NNX<span className="text-[#EAB308]">Changer</span></h1>
          <p className="text-[#64748B] text-sm mt-1 uppercase tracking-widest">Money Changer Treasury</p>
        </div>
        <form onSubmit={submit} className="nnx-card p-6 space-y-4">
          <div>
            <label className="label">Email</label>
            <input data-testid="login-email" className="nnx-input mt-1.5" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@nnxchanger.com" required />
          </div>
          <div>
            <label className="label">Password</label>
            <input data-testid="login-password" className="nnx-input mt-1.5" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />
          </div>
          {err && <div data-testid="login-error" className="text-sm text-rose-400 bg-rose-500/10 border border-rose-500/30 rounded-lg px-3 py-2">{err}</div>}
          <button data-testid="login-submit" type="submit" disabled={loading} className="btn-gold w-full flex items-center justify-center gap-2">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null} MASUK
          </button>
        </form>
      </div>
    </div>
  );
}
